import apiClient from '@/lib/axios';
import type { ApiResponse } from '../types';
import type {
  LeadSearchRequest,
  LeadSearchResult,
  LeadSearchResultItem,
} from '../types/leadSearch';

/**
 * Search leads with comprehensive filters and pagination
 */
export const searchLeads = async (
  request: LeadSearchRequest
): Promise<LeadSearchResult<LeadSearchResultItem>> => {
  // Clean up empty string values before sending to API
  const params: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(request)) {
    if (value !== '' && value !== undefined && value !== null) {
      params[key] = value;
    }
  }

  const response = await apiClient.get<
    ApiResponse<LeadSearchResult<LeadSearchResultItem>>
  >('/leads/search', { params });

  return response.data.data;
};
